import { sleep } from "./time.js";

function loadImageFromSrc(src) {
	return new Promise((resolve, reject) => {
		const image = new Image();
		image.onload = function onLoad() {
			resolve(image);
		};
		image.onerror = () => {
			reject(new Error("Failed to load image"));
		};
		image.src = src;
	});
}

function shuffleIndices(length) {
	const pixels = [];

	for (let i = 0; i < length; i++) {
		pixels.push(i);
	}

	let m = pixels.length;

	while (m) {
		const i = (Math.random() * --m) >>> 0;
		[pixels[m], pixels[i]] = [pixels[i], pixels[m]];
	}

	return pixels;
}

export async function drawFullImageOnCanvas(canvas, imageSrc) {
	const context = canvas.getContext("2d");
	const image = await loadImageFromSrc(imageSrc);
	const canvasWidth = Math.ceil(image.width * window.devicePixelRatio);
	const canvasHeight = Math.ceil(image.height * window.devicePixelRatio);

	canvas.width = canvasWidth;
	canvas.height = canvasHeight;
	context.imageSmoothingEnabled = false;
	context.drawImage(image, 0.0, 0.0, canvas.width, canvas.height);
}

export async function runPixelShuffleTransition(canvas, imageSrc, shouldAbort) {
	const imageData = await loadImageFromSrc(imageSrc);
	const context = canvas.getContext("2d");
	const canvasWidth = Math.ceil(imageData.width * window.devicePixelRatio);
	const canvasHeight = Math.ceil(imageData.height * window.devicePixelRatio);

	if (canvasWidth !== canvas.width || canvasHeight !== canvas.height) {
		canvas.width = canvasWidth;
		canvas.height = canvasHeight;
	}

	const transitionPixelSize = canvas.width / 50.0;
	const width = Math.ceil(canvas.width / transitionPixelSize);
	const height = Math.ceil(canvas.height / transitionPixelSize);
	const pixels = shuffleIndices(width * height);
	const dpr = window.devicePixelRatio;

	for (let index = 0; index < pixels.length; index++) {
		if (shouldAbort() === true) {
			return;
		}

		const i = pixels[index];
		const x = i % width;
		const y = Math.floor(i / width);

		context.drawImage(
			imageData,
			(x * transitionPixelSize) / dpr,
			(y * transitionPixelSize) / dpr,
			transitionPixelSize / dpr,
			transitionPixelSize / dpr,
			x * transitionPixelSize - 0.5,
			y * transitionPixelSize - 0.5,
			transitionPixelSize + 1.0,
			transitionPixelSize + 1.0
		);

		if (index % 60 === 0) {
			await sleep(10);
		}
	}
}
